import { getEvenSource } from "@/components/GlobleModal/LoginModal/service";
import { getSource, getSafePlatformCode } from "./sensors_utils";

/**
 * 查询不到的来源统一定义为default-default,不跟指定的邀请信息挂钩
 * @param defaultSource
 * @returns
 */
export async function getEventTrackSource(defaultSource?: string) {
  /**
   * 获取URL搜索参数
   * @param key 参数名
   * @returns 参数值
   */
  function getSearchParams(key: string): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  }

  let eventTrackSource = defaultSource;
  if (!eventTrackSource) {
    if (window.holopixTrackSource) return decodeURIComponent(window.holopixTrackSource);
    eventTrackSource = "default-default";
  }

  if (getSearchParams("inviteCode")) {
    eventTrackSource = "invitation-code";
  }

  const urlParamsSource = getSource();

  try {
    //渠道code
    const platformCode = getSafePlatformCode();

    if (platformCode || urlParamsSource) {
      //识别推广码-查询不到会返回默认值default-default
      const { data } = await getEvenSource({ platformCode: platformCode, source: urlParamsSource });

      eventTrackSource = data.source;
      window.holopixTrackSource = encodeURIComponent(eventTrackSource);
      return eventTrackSource;
    }
  } catch (error) {
    console.warn("获取事件追踪来源失败:", error);
  }

  return eventTrackSource;
}
